document.addEventListener('turbolinks:load', function() {
  var ctaBtn = document.querySelector('.limited-offer-banner__cta');
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function() {
      var url = ctaBtn.dataset.clickUrl;
      if (!url) return;

      var csrfToken = document.querySelector('meta[name="csrf-token"]');
      var token = csrfToken ? csrfToken.content : '';

      fetch(url, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': token,
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        keepalive: true
      });
    });
  }

  var dismissBtn = document.querySelector('.limited-offer-banner__dismiss');
  if (!dismissBtn) return;

  dismissBtn.addEventListener('click', function() {
    var banner = document.querySelector('.limited-offer-banner');
    var url = dismissBtn.dataset.dismissUrl;

    if (!url || !banner) return;

    var csrfToken = document.querySelector('meta[name="csrf-token"]');
    var token = csrfToken ? csrfToken.content : '';

    fetch(url, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': token,
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    }).then(function(response) {
      if (response.ok) {
        banner.style.transition = 'opacity 0.3s, max-height 0.3s';
        banner.style.opacity = '0';
        banner.style.maxHeight = '0';
        banner.style.overflow = 'hidden';
        banner.style.padding = '0';
        setTimeout(function() {
          banner.remove();
        }, 300);
      }
    });
  });
});
